import React__default from 'react';
import cn from 'classnames';
import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../../Button/index.js';
import { Foldable } from '../../Foldable/index.js';
import styles from 'ui-components/FilterMenu/FilterContainer.scss';

var DefaultChevronIcon = function DefaultChevronIcon(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8 4l8 8-8 8",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd"
  }));
};
var FilterContainer = function FilterContainer(_ref) {
  var _cn;
  var openFilter = _ref.openFilter,
    setOpenFilter = _ref.setOpenFilter,
    filterName = _ref.filterName,
    children = _ref.children,
    _ref$ChevronIcon = _ref.ChevronIcon,
    ChevronIcon = _ref$ChevronIcon === void 0 ? DefaultChevronIcon : _ref$ChevronIcon,
    activeFilterValue = _ref.activeFilterValue;
  var filterValue = function filterValue() {
    if (activeFilterValue === undefined || activeFilterValue === null) {
      return "";
    }
    if (typeof activeFilterValue === "string") {
      return /*#__PURE__*/React__default.createElement("span", null, " (" + activeFilterValue + ")");
    }
    if (typeof activeFilterValue === "object" && activeFilterValue.length > 0) {
      return /*#__PURE__*/React__default.createElement("span", null, " (" + activeFilterValue.length + ")");
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, (_cn = {}, _cn[styles.open] = openFilter === filterName, _cn))
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: styles.block__header,
    onClick: function onClick() {
      return setOpenFilter(openFilter === filterName ? "" : filterName);
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, filterName, filterValue()), /*#__PURE__*/React__default.createElement(ChevronIcon, {
    className: styles.closeIcon
  })), /*#__PURE__*/React__default.createElement(Foldable, {
    open: openFilter === filterName
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.body
  }, children)));
};

export { FilterContainer };
//# sourceMappingURL=index.js.map
